export default __webpack_public_path__ + "static/media/catalogo-libri-nc.40bd5214.svg";